<div style="display: grid; grid-template-columns: auto 20px; align-items: center;">

  @if (!isEditing) {
    <div class="tooltip">{{ crewMember?.firstName ?? '-' }}
      @if (crewMember) {
        <span
        class="tooltiptext">{{ crewMember?.getFullName() }}</span>
      }
    </div>
    @if (earlyShift) {
      <ion-icon class="early-shift-icon"
      name="alarm-outline"></ion-icon>
    }
  } @else {
    <ion-select
      (ionChange)="setCrewMember($event)"
      [interfaceOptions]="{ cssClass: 'action-sheet-eventslight' }"
      [value]="crewMember?.id"
      class="action-sheet-eventslight"
      data-cy="select-stagemanager"
      interface="action-sheet"
      name="stagemanager"
      placeholder="-"
      required
      >
      @for (user of users; track user) {
        <ion-select-option [value]="user.id">
          {{ user?.firstName }} {{ user?.lastName }}
        </ion-select-option>
      }
    </ion-select>
    <ion-checkbox
      (ionChange)="setEarlyShift($event)"
      [checked]="earlyShift"
      color="secondary"
      mode="ios"
      />
    }


  </div>
